import {type ChangeEvent, useState} from "react";
import { useTranslation } from "react-i18next";

interface JobProps {
    jobData: string
}

const Job = ({jobData}: JobProps) => {
    const { t } = useTranslation('ui');

    const [selectedData, setSelectedData] = useState("");
    const [otherValue, setOtherValue] = useState("");

    const data = jobData.split(",").map(name => name.trim());
    if (data.length == 1 && data[0] == "") {
        data.pop();
    } else {
        data.push("ETC");
    }

    const handleSelectChange = (e: ChangeEvent<HTMLSelectElement>) => {
        const value = e.target.value;
        setSelectedData(value);

        if (value !== "ETC") {
            setOtherValue("");
        }
    };


    return (
        <div className="signup_container">
            <label htmlFor="selected_job">{t("signUp.job")}</label>
            {
                data.length > 0 &&
                <select
                    name="selected_job"
                    className="form-select custom-input"
                    style={{ height: "3rem" }}
                    defaultValue={selectedData}
                    key={selectedData}
                    onChange={handleSelectChange}
                >
                    <option disabled={true} value="">{t("signUp.selectJob")}</option>
                    {data.map((option) => (
                        <option key={option} value={option}>
                            {option}
                        </option>
                    ))}
                </select>
            }
            {
                (data.length == 0 || selectedData == "ETC") &&
                <div className="d-flex align-items-center mt-3">
                    <span style={{whiteSpace: "nowrap"}}>{t("signUp.jobOther")}</span>
                    <input type="text"
                           value={otherValue}
                           name="job"
                           className="form-control rounded-4 bg-light px-3 ms-3"
                           onChange={e => setOtherValue(e.target.value)}
                    />
                </div>
            }
        </div>
    )
}

export default Job;